const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const updateGroup= (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_GROUP_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_GROUP_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default updateGroup;